module.exports = __webpack_public_path__ + "img/holidu.fe31c60b.png";